import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class ExamService {

  ExamAttendanceNo: any;
  Course: any;
  FormNumber: any;
  LanguageID: number = 0;

  private apiUrl = 'https://exam.alarkkan.app/api/api/call';
  private TrainingAppUrl = 'https://alarkkan.app/api/SendExamConfirmation';
  private sendResultToTrainingApp  = 'https://alarkkan.app/api/booking/exam/complete'


  constructor(private http: HttpClient, private permissionsService: PermissionsService) { }

  getTraineeDetailsByExamAttendanceNo(ExamAttendanceNumber: string, LanguageID:number): Observable<any> { // From ExamApp
    this.LanguageID = LanguageID;
    this.ExamAttendanceNo = ExamAttendanceNumber;
    const body = {
      procedureName: 'GetTraineeDetailsByExamAttendanceNo',
      params: {
        ExamAttendanceNumber: ExamAttendanceNumber,
      },
    };
    return this.http.post<any>(this.apiUrl, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getExamByAttendanceNo(ExamAttendanceNumber: string): Observable<any> { // From ExamApp T_Exam
    const body = {
      procedureName: 'sp_GetExamByAttendanceNo',
      params: {
        ExamAttendanceNo: ExamAttendanceNumber
      },
    };
    return this.http.post<any>(this.apiUrl, body, {
      headers: { 'Content-Type': 'application/json' },
    });
  }

  startExam(examAttendanceNo: string, examId: number, formNo: string, langID: number): Observable<any> {
    this.FormNumber = formNo;
    this.LanguageID = langID;
    this.Course = examId;
    const body = {
      procedureName: 'SaveExamDetails',
      params: {
        ExamAttendanceNo: examAttendanceNo,
        ExamID: examId,
        FormNo: formNo,
        LangID: langID,
        CreatedBy: this.permissionsService.getUserId(),
        StartExamDate: new Date().toISOString(),
        ExamResult: 'In Progress',
      }
    };
    
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
  

  submitStudentAnswer(submitQustion:any): Observable<any> {
    const body = {
      procedureName: 'sp_SubmitStudentAnswer',
      params: {
        ExamAttendanceNo: submitQustion.ExamAttendanceNo,
        ExamID: submitQustion.ExamID,
        QuestionID: submitQustion.QuestionID,
        IsSkipped: submitQustion.IsSkipped,
        IsPostponed: submitQustion.IsPostponed,
        IsAnswered: submitQustion.IsAnswered,
        LanguageID: submitQustion.LanguageID,
        SelectedAnswerID: submitQustion.SelectedAnswerID,
        IsCorrect: submitQustion.IsCorrect,
        Score: submitQustion.Score,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  questionSkip(skipThisQuestion:any): Observable<any> {
    const body = {
      procedureName: 'sp_SkipQuestion',
      params: {
        LanguageID: skipThisQuestion.LanguageID,
        QuestionID: skipThisQuestion.QuestionID,
        QuestionLevel: skipThisQuestion.QuestionLevel,
        QuestionType: skipThisQuestion.QuestionType,
        UnitID: skipThisQuestion.UnitID,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  updateExamStatus(examStutus:any): Observable<any> {
    const body = {
      procedureName: 'sp_UpdateExamStatus',
      params: {
        AttemptID: examStutus.AttemptID,
        Marks: examStutus.Marks,
        ExamResult: examStutus.ExamResult,
        EndExamTime: examStutus.EndExamTime,  
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }


  getExamStatus(examAttendanceNo: string): Observable<any> {
    const body = {
      procedureName: 'sp_GetExamStatus',
      params: {
        ExamAttendanceNo: examAttendanceNo
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getExamResult(ExamAttendanceNo: string): Observable<any> {
    const body = {
      procedureName: 'sp_GetExamResults',
      params: {
        ExamAttendanceNo: ExamAttendanceNo
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  sendExamResultToTrainingApp(IDnumber:number, ExamResult: string ): Observable<any> { // Msg SMS or Email
    const body = {
      id: IDnumber,
      status: ExamResult,
    };
    return this.http.post<any>(this.TrainingAppUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  sendTraineeResultToTrainingApp(BookingId:number, StudentId: number, Score: number ): Observable<any> { // Msg SMS or Email
    const body = {
      bookingId: BookingId,
      studentId: StudentId,
      score: Score
    };
    return this.http.patch<any>(this.sendResultToTrainingApp, body, { headers: { 'Content-Type': 'application/json' } });
  }


  getLanguageList(): Observable<any> {
    const body = {
      procedureName: 'sp_GetLanguages',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getServerTimeLocal(): Observable<any> {
    const body = {
      procedureName: 'usp_GetServerTimeLocal',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
}